import React from 'react';
import { Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';

interface FilterBarProps {
    /** Search input placeholder; omit `onSearch` to hide the search box. */
    searchPlaceholder?: string;
    onSearch?: (value: string) => void;
    searchValue?: string;
    /** Filter controls (Selects, Segmented, etc.) rendered after the search box. */
    children?: React.ReactNode;
    /** Right-aligned content (counts, secondary buttons). */
    right?: React.ReactNode;
}

/** Vertical divider between filter groups inside a FilterBar. */
export const FilterDivider: React.FC = () => <div className="w-px h-5 bg-border mx-1" />;

/**
 * Standard filter bar shown between the PageHeader and the table.
 * Search first, then filter Selects (size="small" variant="borderless").
 */
const FilterBar: React.FC<FilterBarProps> = ({ searchPlaceholder = 'Search...', onSearch, searchValue, children, right }) => (
    <div className="flex flex-wrap items-center gap-2 bg-card border border-border rounded-xl px-4 py-3 shadow-sm mb-4">
        {onSearch && (
            <>
                <Input
                    placeholder={searchPlaceholder}
                    prefix={<SearchOutlined className="text-muted-foreground" />}
                    style={{ width: 200, maxWidth: '100%' }}
                    allowClear
                    size="small"
                    variant="borderless"
                    className="bg-muted/40 rounded-lg flex-1 min-w-[140px]"
                    value={searchValue}
                    onChange={e => onSearch(e.target.value)}
                />
                {children && <FilterDivider />}
            </>
        )}
        {children}
        {right && <div className="ml-auto flex items-center gap-2">{right}</div>}
    </div>
);

export default FilterBar;
